import agent from './agent'
import role from './util/role';
import jwtDecode from 'jwt-decode';
import { init as webSocketInit } from './util/websockets'
import {
  ASYNC_START,
  ASYNC_END,
  APP_LOAD,
  LOGIN,
  LOGOUT,
  LOGIN_PAGE_VERIFY_PIN_CODE,
  LOAD_BASE_COIN_ACCOUNT,
  VERIFY_USER_PIN
} from './constants/actionTypes'

const promiseMiddleware = store => next => action => {
  if (isPromise(action.payload)) {
    store.dispatch({ type: ASYNC_START, subtype: action.type });

    const currentView = store.getState().viewChangeCounter;
    const skipTracking = action.skipTracking;

    action.payload.then(
      res => {
        const currentState = store.getState()
        if (!skipTracking && currentState.viewChangeCounter !== currentView) {
          return
        }
        console.log('RESULT', res);
        action.payload = res;
        store.dispatch({ type: ASYNC_END, promise: action.payload });
        store.dispatch(action);
      },
      error => {
        const currentState = store.getState()
        if (!skipTracking && currentState.viewChangeCounter !== currentView) {
          return
        }
        console.log('ERROR', error);
        action.error = true;
        action.payload = error.response ? error.response.data : null;
        if (!action.skipTracking) {
          store.dispatch({ type: ASYNC_END, promise: action.payload });
        }
        //token is expired or inadequate permissions
        if (error.response && error.response.status === 401) {
          store.dispatch({ type: 'LOGOUT' });
        }
        store.dispatch(action);
      }
    );

    return;
  }
  next(action)
}

const localStorageMiddleware = store => next => action => {
  if (action.type === LOGIN || action.type === LOGIN_PAGE_VERIFY_PIN_CODE || action.type === VERIFY_USER_PIN) {
    if (!action.error && action.payload && action.payload.user && action.payload.user.token) {
      var decoded = jwtDecode(action.payload.user.token);
      // only allows merchants
      if (!role.isMerchant(decoded.role)) {
        action.error = true;
        action.payload.error = { message: 'You are not authorized to login.' };
        store.dispatch({ type: ASYNC_END, promise: action.payload });
        store.dispatch(action);
        return
      } else {
        window.localStorage.setItem('pellar-merchant-web-token', action.payload.user.token)
        agent.setToken(action.payload.user.token)
      }
    }
  } else if (action.type === LOGOUT) {
    window.localStorage.setItem('pellar-merchant-web-token', '')
    agent.setToken(null)
  }
  next(action)
}

const socketMiddleware = store => next => action => {
  if (action.type === APP_LOAD) {
    if (!action.error && action.payload && action.payload.user && action.token && action.payload.user.currency_code) {
      const payload = agent.Common.getBaseSymbolAccountDetail(action.payload.user.currency_code)
      store.dispatch({ type: LOAD_BASE_COIN_ACCOUNT, payload, token: action.token });
      //directly init socket
      // webSocketInit(action.token, action.payload[1].account.external, store)
    }
  } else if (action.type === LOGIN || action.type === LOGIN_PAGE_VERIFY_PIN_CODE || action.type === VERIFY_USER_PIN) {
    if (!action.error && action.payload && action.payload.user && action.payload.user.token && action.payload.user.currency_code) {
      // 1. get base coin account
      const payload = agent.Common.getBaseSymbolAccountDetail(action.payload.user.currency_code)
      store.dispatch({ type: LOAD_BASE_COIN_ACCOUNT, payload, token: action.payload.user.token });
    }
  } else if (action.type === LOAD_BASE_COIN_ACCOUNT) {
    if (!action.error) {
      // 2. init socket
      webSocketInit(action.token, action.payload.account.external, store)
    }
  }
  next(action)
}

function isPromise(v) {
  return v && typeof v.then === 'function'
}

export { promiseMiddleware, localStorageMiddleware, socketMiddleware }
